<template>
  <header>
    <div class="logo">
      <ThreeflowWordmark />
    </div>
    <h2
      v-if="title"
      v-text="title"
    />
  </header>
</template>

<script>
/**
 * WatchTower Auth Flow Header
 *
 * @vuedoc
 * @exports AuthenticationHeader
 * @category Components
 */

  export default {
    name: 'AuthenticationHeader',
    props: {
      title: {
        type: String,
        default: null,
      },
    },
  };
</script>

<style scoped lang="scss">
  .logo {
    display: block;
    margin: 0 auto 45px;
  }
</style>
